export default "__VITE_ASSET__B8KU7dnP__"